module.exports = __webpack_public_path__ + "assets/column-2.c87ffd18.svg";